import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { POLICY_DOCUMENTS_NAME, RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { StatusCode, Modules, DocumentFileType } from 'src/app/_common/_enum/module.enum';
import { HeaderData } from 'src/app/_models/header-data';
import { AccountService } from '../_services/account.service';
import * as _ from "lodash";
import { PolicyListByAccountCriteria } from '../policy-list-by-account/_models/policy-list-by-account-criteria';
import { PolicyDocumentsFilterCriteria } from './_models/policy-documents-filter-criteria';
import { SortableDirective, SortEvent } from 'src/app/_directives/sortable.directive';


export enum FilterTypes{
  YEAR = "year",
  POLICY_NUMBERS = "policyNumber",
  DOCUMENT_TYPES = "documentType"
}
@Component({
  selector: 'app-document-by-account',
  templateUrl: './document-by-account.component.html',
  styleUrls: ['./document-by-account.component.scss']
})
export class DocumentByAccountComponent implements OnInit, OnDestroy {
  resultsNotFound = RESULTS_NOT_FOUND;
  FilterTypes = FilterTypes;
  private loading: boolean = false;                       //Using it in HTML
  private filterLoading: boolean = false;                 //Using it in HTML
  private reportLoading: boolean = false;                 //Using it in HTML
  private hasAccess: boolean = true;                      //Using it in HTML
  private hasError: boolean = false;                      //Using it in HTML
  private agencyNoticeSearch: boolean = true;            //Using it in HTML
  //private noData: boolean = false;
  private yearChanged: boolean = false;
  private isInit = true;
  private _total$ = new BehaviorSubject<number>(0);
  private criteria: PolicyDocumentsFilterCriteria;
  private accountNumber;
  private selectedAccount;
  
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;
  
  private policyDocumentsConfig = POLICY_DOCUMENTS_NAME;  //All policyDocuments type listed in PRODUCT CONFIG
 
  private filteredPolicyDocumentList;                     //Right side panel list object 
  private policyDocumentList;                             //Right side panel list object    
  private allData = [];
  private allNestedData = [];

  private allPolicyNumbers = [];
  
  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;  
  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;
  constructor(private readonly route: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit() {
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {
      this.accountNumber = params.get("id").toString();
    });
    this.selectedAccount = this.accountService.getAccountData();
    
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.showEndorsementsTab();
    this.retrieveBasicHeaderData(); //Retrieve the basic details of account and Set the Header..
  }
  get ModuleEnum(){ return Modules; }
  setHeaderData(){
    this.headerData.pageTitle = this.selectedAccount.accountName;//.toLowerCase();
    this.headerData.breadcrumb = [{itemName: "Account Overview" , itemLink: ""}];
    this.headerData.subTitle = "Account #: " + this.selectedAccount.accountNumber;
    this.accountService.header = this.headerData;
  }
  retrieveBasicHeaderData(){
    /* Setting Headers Starts */
    this.headerData = new HeaderData();

    this.selectedAccount = this.accountService.getAccountData();
      this.filterLoading = true;
      
      let filters:PolicyListByAccountCriteria = new PolicyListByAccountCriteria();
      filters.accountNumber = this.accountNumber;
      filters.sortBy = "accountName";
      filters.sortOrder = "asc";
      let accountByAccountSubscription = this.accountService.fetchAccountByAccountNumber(filters).subscribe((accountData:any)=>{
        this.filterLoading = false;
        if (accountData.policies && accountData.policies.length > 0) {
          //let showEndt = this.selectedAccount.showEndorsementsTab;
          this.allData = accountData.policies;
          //this.selectedAccount = accountData.policies[0];
          //bring the show endt flag back after loading data
          //this.selectedAccount.showEndorsementsTab = showEndt ? showEndt : null;
          this.accountService.storeAccountData({"accountName": this.selectedAccount.accountName, "accountNumber": this.selectedAccount.accountNumber, "accountEndorsementsTab": this.selectedAccount.accountEndorsementsTab});
          
          this.allData.map((_data) => _data.year = new Date(_data.policyEffectiveDate).getFullYear())
          this.allData.sort((a: any, b: any) => (a.year < b.year) ? 1 : -1);

          //this.fetchPolicyDocumentFilterData();
          this.makeNestedData(this.isInit);
          this.getFilteredPolicyNumbers(this.isInit);
          this.makeDocumentTypesData(this.isInit);

          this.fetchPolicyDocumentList();
        }
        this.setHeaderData();
      },error=>{
        this.filterLoading = false;
        this.setHeaderData();
      });

      this.accountService.runningServices.push(accountByAccountSubscription);
    /* Setting Headers Ended */
  }
  
  get total$() { return this._total$.asObservable(); }

  /** makeNestedData - make data nested from the flat structure to show on Left Panel
   *  if isInit is true then show default view Latest Year selected, All Policies selected, All Documents selected
   */
  makeNestedData(isInit = false) {
    this.allNestedData = [{year: '', displayName: "All Years", isSelected:false, policies: []}];
    this.allData.forEach((data,ind) => {
      if(this.allNestedData.find(_data=>_data.year == data.year)){
        let yearData = this.allNestedData.find(_data => _data.year == data.year);
        data.displayName = data.policyNumber;
        yearData.policies.push(data);
      }else{
        data.displayName = data.policyNumber;
        this.allNestedData.push({year: data.year, displayName:data.year, isSelected: (isInit && ind == 0), policies: [data]});
      }
    }, []);
  }
  
  makeDocumentTypesData(isInit = false) {
    this.policyDocumentsConfig.forEach(_nestedData => {
        _nestedData.isSelected = isInit;
      });
  }

  /** getFilteredPolicyNumbers - Generate policies  */
  getFilteredPolicyNumbers(isInit = false) {
    let filteredYears = _.cloneDeep(this.allNestedData);
    filteredYears = filteredYears.filter((_year) => _year.isSelected);

    this.allPolicyNumbers = [];
    if(filteredYears.length>0)
      this.allPolicyNumbers = [{ year: "", displayName: "All Policies", policyNumber: "", isSelected: false }];
    
    if (isInit) {
      this.allPolicyNumbers[0].isSelected = true;
    }

    filteredYears.forEach((_year, _ind) => {
      _year.policies.forEach((_policy, _pInd) => {
        if (isInit) {
          _policy.isSelected = true;
        }
        this.allPolicyNumbers.push(_policy);
      });
    });

    return this.allPolicyNumbers;
  }
  /** changeCheckboxValue is used on change of Checkboxes.*/
  changeCheckboxValue($event, $_type) {
    if ($_type == FilterTypes.YEAR) {
      this.yearChanged = true;
      if (!$event.target.checked) {
        this.allNestedData[0].isSelected = false;
      }
      if ($event.target.dataset.year == "") {
        this.allNestedData.forEach(_nestedData => {
          _nestedData.isSelected = $event.target.checked;
        });
      }/*  else {
        if (this.allNestedData.filter(_nestedData => { _nestedData.year != '' && _nestedData.isSelected == true; }).length == this.allNestedData.length-1) {
          this.allNestedData.find(_nestedData => _nestedData.year == '').isSelected = true;
        }
      } */
      this.getFilteredPolicyNumbers();
    } else if ($_type == FilterTypes.POLICY_NUMBERS) {
      if (!$event.target.checked) {
        this.allPolicyNumbers[0].isSelected = false;
      }
      if ($event.target.dataset.policy == "") {
        this.allPolicyNumbers.forEach(_nestedData => {
          _nestedData.isSelected = $event.target.checked;
        });
      } /* else {
        if (this.allPolicyNumbers.filter(_nestedData => { _nestedData.policyNumber != '' && _nestedData.isSelected == true; }).length == this.allPolicyNumbers.length-1) {
          this.allPolicyNumbers.find(_nestedData => _nestedData.policyNumber == '').isSelected = true;
        }
      } */
    } else if ($_type == FilterTypes.DOCUMENT_TYPES) {
      if (!$event.target.checked) {
        this.policyDocumentsConfig[0].isSelected = false;
      }
      if ($event.target.dataset.docid == "" || $event.target.dataset.docid == "0") {
        this.policyDocumentsConfig.forEach(_nestedData => {
          _nestedData.isSelected = $event.target.checked;
        });
      } /* else {
        if (this.policyDocumentsConfig.filter(_nestedData => { _nestedData.id != 0 && _nestedData.isSelected == true; }).length == this.policyDocumentsConfig.length-1) {
          this.policyDocumentsConfig.find(_nestedData => { _nestedData.id == 0 }).isSelected = true;
        }
      } */
    }
  }

  /** fetchPolicyDocumentList - fetch the list of policyDocuments based on the selected Filters. */
  fetchPolicyDocumentList() {
    this.isInit = false;
    this.criteria = new PolicyDocumentsFilterCriteria();
    this.criteria.accountNumber = this.accountNumber;
    this.criteria.years = this.allNestedData.filter(_data => _data.year!='' && _data.isSelected).map(function (el) { return el.year; });
    this.criteria.policyNumbers = this.allPolicyNumbers.filter(_data => _data.policyNumber != '' && _data.isSelected).map(function (el) { return el.policyNumber; });
    if (this.policyDocumentsConfig[0].isSelected) {
      this.criteria.documentTypes = this.policyDocumentsConfig[0].documentTypes;
    }else{
      this.criteria.documentTypes = [].concat.apply([], this.policyDocumentsConfig.filter(_data => _data.id != 0 && _data.isSelected).map(function (el) { return el.documentTypes; }));
      this.agencyNoticeSearch = (this.criteria.documentTypes.find(doc=> doc==DocumentFileType.NOC || doc==DocumentFileType.Rescission)) ? true : false;
    }
    
    if (this.criteria.years.length > 0 && this.criteria.policyNumbers.length > 0 && this.criteria.documentTypes.length > 0) {
      this.loading = true;
      this.yearChanged = false;
      this.hasError = false;
      let policyDocumentListSubscription = this.accountService.fetchPolicyDocumentList(this.criteria).subscribe((policyDocumentFilterData: any) => {
        this.loading = false;
        this.policyDocumentList = policyDocumentFilterData;
        //this.noData = false;//(!this.policyDocumentList || this.policyDocumentList.length == 0);
        this.policyDocumentList.forEach(policyDocument => {
          policyDocument.isDownloading = false;
        });

        this.filterDocumentList();
      },
        error => {
          this.loading = false;
          this.hasAccess = !(error.status == StatusCode.NoAccess);
          this.hasError = true;
          //this.noData = false;
          this.policyDocumentList = [];
          this.filterDocumentList();
      });

      this.accountService.runningServices.push(policyDocumentListSubscription);
    }
  }

  /** Filter documentList */
  filterDocumentList() {
    /* if (this.noData || this.yearChanged || this.hasError) {
      this.fetchPolicyDocumentList();
    } else { */
      //this.noData = (!this.policyDocumentList || this.policyDocumentList.length == 0); 
      this.criteria.years = this.allNestedData.filter(_data => _data.year!='' && _data.isSelected).map(function (el) { return el.year; });
      this.criteria.policyNumbers = this.allPolicyNumbers.filter(_data => _data.policyNumber != '' && _data.isSelected).map(function (el) { return el.policyNumber; });
      this.criteria.documentTypes = [];
      if (this.policyDocumentsConfig[0].isSelected) {
        this.criteria.documentTypes = this.policyDocumentsConfig[0].documentTypes;
      }else{
        this.criteria.documentTypes = [].concat.apply([], this.policyDocumentsConfig.filter(_data => _data.id != 0 && _data.isSelected).map(function (el) { return el.documentTypes; }));
      }
      
      if (this.criteria.years.length > 0 && this.criteria.policyNumbers.length > 0 && this.criteria.documentTypes.length > 0) {
        this.filteredPolicyDocumentList = this.policyDocumentList.filter(_data => this.criteria.years.includes(parseInt(_data.year)) && this.criteria.policyNumbers.includes(_data.policyNumber) && this.criteria.documentTypes.includes(_data.documentTypeName));
      }
      this._total$.next(this.filteredPolicyDocumentList.length);
    //}
  }
  /** downloadPolicyDocument - to download the policyDocument, AccountId and DocumentId are the parameters. */
  
  getPolicyDocumentName(_type) {
    let subName = "";
    if (_type.toLowerCase().indexOf("reissue") > -1) {
      subName = " Reissue";
    }
    
    return this.policyDocumentsConfig.find(_doc => _doc.documentTypes.includes(_type) && _doc.id != 0).displayName + subName;
  }

  downloadPolicyDocument(policyDocument) {
    policyDocument.isDownloading = true;
    let policyDocumentDownloadSubscription = this.accountService.downloadPolicyDocument(policyDocument.accountNumber, policyDocument.documentId, this.getPolicyDocumentName(policyDocument.documentTypeName)).subscribe((policyDocumentFilterData: any) => {
      policyDocument.isDownloading = false;
    },
    error => {
      policyDocument.isDownloading = false;
      this.accountService.openModal('error', 'none');
    });
    this.accountService.runningServices.push(policyDocumentDownloadSubscription);
  }

  showEndorsementsTab(){
    let getEndtFlag = this.accountService.endtTabFlag(this.selectedAccount).subscribe( (result: boolean) => { this.selectedAccount.accountEndorsementsTab = result });
    this.accountService.runningServices.push(getEndtFlag);
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    this.accountService.openModal('none', this.lossRunMessageModal);
    this.accountService.downloadLossRunReport(this.selectedAccount.accountNumber, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.accountService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.accountService.hasOpenModals();
      if (hasOpenModals) {
        this.accountService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.accountService.openModal('none', this.lossRunErrorModal);
        }, 50);
      } 
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.accountService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }

  /* ***Sorting Code*** */
  compare(v1, v2) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;

      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      return this.doSort(column, direction);
    }
  }

  doSort(column, direction){
    return this.filteredPolicyDocumentList.sort((a, b) => {
      const res = this.compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
  /* Sorting Code */
  
  onPageChange(){
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
